import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer, UntypedFormGroup } from '@angular/forms';
import { EmployeeCompany } from '../../models/EmployeeCompany';

@Component({
  selector: 'app-employee-company-form',
  templateUrl: './employee-company-form.component.html',
  styleUrls: ['./employee-company-form.component.scss'],
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (container: ControlContainer) => container,
    deps: [[new SkipSelf(), ControlContainer]]
    }]
})

export class EmployeeCompanyFormComponent implements OnInit {


  @Input() form: UntypedFormGroup;

  editMode: boolean;
  employeeCompany: EmployeeCompany;

  ngOnInit(): void {

    this.employeeCompany = this.form.value;
    this.editMode = this.employeeCompany.id > 0;
  }

}

